import { postData, getData } from '@/utils/fetch';
import * as apiType from './type';
import { getOrgIdPath } from '@/utils/tool';
import { AppItem } from '@/types/email-types';

const baseUrl = '/api/console/';

//可购买域名查询
export function getDomail(appId: string) {
  return getData<{ name: string }[]>(
    baseUrl + 'sub' + getOrgIdPath(`Email/${appId}/domail/passedlist`),
  );
}
//可购买IP查询
export function getIpPublist(appId: string) {
  return getData<{ ip: string; loc: string; ipId: string }[]>(
    baseUrl + 'sub' + getOrgIdPath(`Email/${appId}/ind_ip/publist`),
  );
}
//查询已开通独立IP
export function getIpList(appId: string) {
  return getData<{ ip: string; remains: number; ipId: string; domain: string }[]>(
    baseUrl + 'sub' + getOrgIdPath(`Email/${appId}/ind_ip/list`),
  );
}
//计算订单费用
export function getCostInfo(params: apiType.createDetailsType[], appId: string) {
  return postData<{ cost: number }>(baseUrl + 'charge' + getOrgIdPath('email/cost-info'), {
    details: params,
    appId,
  });
}

// 判断组织是否首次购买邮件进箱预览服务
export function firstPurchase() {
  return getData<{ isFirstPurchaseInboxPreview: boolean; isFirstPurchaseFlashAi: boolean }>(
    baseUrl + 'order' + getOrgIdPath('email-services/is-first-purchase'),
  );
}

// 获取Email应用列表
export function getEmailAppList(orgId: string) {
  return getData<{ userDcs: AppItem[] }>(`/api/email/user_dc/list.do`, {
    orgId,
    business: 'Email',
  });
}
